module.exports = __webpack_public_path__ + "static/media/canteen-1.e199c1b2.png";